import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

export const ePlantTreeTagClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    ePlantTreeTag: {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "ePlant",
        modelName: "TreeTag",
        friendlyName: "ePlant TreeTag",
        friendlyShortName: "TreeTag",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "stemRadiusChange",
                parameters: {},
                legalConvertedRange: [-32000, 32000],
                subChannel: 0,
            },
            { sensorElementConfigKey: "solarRadiation", parameters: {}, legalConvertedRange: [0, null], subChannel: 1 },
            { sensorElementConfigKey: "temperature", parameters: {}, legalConvertedRange: [-20, 82.4], subChannel: 2 },
            { sensorElementConfigKey: "humidity", parameters: {}, legalConvertedRange: [0, 99], subChannel: 3 },
            {
                sensorElementConfigKey: "inclinationAngle",
                parameters: {},
                legalConvertedRange: [0, 180],
                subChannel: 5,
            },
            {
                sensorElementConfigKey: "inclinationDirection",
                parameters: {},
                legalConvertedRange: [0, 360],
                subChannel: 6,
            },
        ],
    },
};
